import LoadingDots from "components/LoadingDots";

type TabCountLabelProps = {
    text: string;
    count?: number | null;
    isLoading?: boolean;
};

const TabCountLabel = ({ text, count, isLoading = false }: TabCountLabelProps) => (
    <span className="tab-count-label">
        {text}
        {isLoading ? <LoadingDots compact /> : count != null && count > 0 ? ` (${count})` : null}
    </span>
);

export default TabCountLabel;
